import { render } from "./NoteViewField.vue?vue&type=template&id=67cef8c8"
import script from "./NoteViewField.vue?vue&type=script&lang=js"
export * from "./NoteViewField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__